import React from 'react'
import { Typography } from 'antd'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'
import { formatCurrency } from '../../../utils/currency'
const { Text } = Typography

interface Props {
  purchaseOrder: CompletedPurchaseOrder
}

export const PurchaseOrderItems: React.FC<Props> = ({ purchaseOrder }) => {
  const { items } = purchaseOrder

  return (
    <table className="w-full mb-8">
      <thead className="bg-gray-50">
        <tr>
          <th className="py-2 px-4 text-left">Item</th>
          {/* <th className="py-2 px-4 text-left">Description</th> */}
          <th className="py-2 px-4 text-right">Quantity</th>
          <th className="py-2 px-4 text-right">Unit Price</th>
          <th className="py-2 px-4 text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => {
          const total = item.quantity * item.costPrice

          // if (item.type === 'lineItem') {
            return (
              <tr key={item.id} className="border-b">
                <td className="py-3 px-4">
                  {item.supplierItemCode && (
                    <Text className="block">{item.supplierItemCode}</Text>
                  )}
                  {item.internalNotes && (
                    <Text className="block">{item.internalNotes}</Text>
                  )}
                  <Text className="font-mono text-sm">
                    {item.code}
                  </Text>
                </td>
                {/* <td className="py-3 px-4">
                <Text strong>{item.name}</Text>
                {item.description && (
                  <Text type="secondary" className="block">
                    {item.description}
                  </Text>
                )}
              </td> */}
                <td className="py-3 px-4 text-right">{item.quantity}</td>
                <td className="py-3 px-4 text-right">
                  {formatCurrency(item.costPrice)}
                </td>
                <td className="py-3 px-4 text-right">
                  {formatCurrency(total)}
                </td>
              </tr>
            )
        })}
      </tbody>
    </table>
  )
}
